import React from 'react';
import { Tooltip, Button } from 'antd';
import { useDispatch } from 'react-redux';
import { notificationConstants } from '../../../../constants/notification.constants';
import { useInfoModalDispatch } from '../../contexts/InfoModalContext';

const AddInfoBtn = () => {
  const dispatch = useDispatch();
  const openModal = useInfoModalDispatch();

  const handleClick = () => {
    dispatch({ type: notificationConstants.NOTIFICATION_CLEAR, payload: null });
    openModal({});
  };

  return (
    <Tooltip title="Новое информирование" placement="bottom">
      <Button type="primary" shape="circle" icon="plus" onClick={handleClick} />
    </Tooltip>
  );
};

export default AddInfoBtn;
